import { applicationActionTypes } from './application-action-types';
import { applicationViewModes } from './application-view-modes';

/*
NOTE: LKG: These actions are designed this way so that the application does
not need to know where it is change know how to get to these view states. We
will think about this a bit more as we keep moving forward.
*/
export const enableAlbumSelectionMode = () => {
	return {
		type: applicationActionTypes.APPLICATION_SELECTION_MODE,
		viewMode: applicationViewModes.APPLICATION_VIEW_ALBUMS,
		selectEnabled: true
	};
};

export const disableAlbumSelectionMode = () => {
	return {
		type: applicationActionTypes.APPLICATION_SELECTION_MODE,
		viewMode: applicationViewModes.APPLICATION_VIEW_ALBUMS,
		selectEnabled: false
	};
};

export const leftNavigationHide = () => {
	return {
		type: applicationActionTypes.APPLICATION_LEFT_NAVIGATION,
		shown: false
	};
};

export const leftNavigationShow = () => {
	return {
		type: applicationActionTypes.APPLICATION_LEFT_NAVIGATION,
		shown: true
	};
};

export const enableAlbumItemSelectionMode = () => {
	return {
		type: applicationActionTypes.APPLICATION_SELECTION_MODE,
		viewMode: applicationViewModes.APPLICATION_VIEW_ALBUM_ITEMS,
		selectEnabled: true
	};
};

export const disableAlbumItemSelectionMode = () => {
	return {
		type: applicationActionTypes.APPLICATION_SELECTION_MODE,
		viewMode: applicationViewModes.APPLICATION_VIEW_ALBUM_ITEMS,
		selectEnabled: false
	};
};
export const setRemoteLoading = (isLoading) => {
	return {
		type: applicationActionTypes.APPLICATION_REMOTE_LOADING,
		isLoading: isLoading
	}
}
//LKG: For ease of use. This API may change, we will see.
export const setAlbumItemViewMode = () => {
	return disableAlbumItemSelectionMode();
};

export const setAlbumsViewMode = () => {
	return disableAlbumSelectionMode();
};

export const toggleHeaderMenuExpanded = () => {
	return {
		type: applicationActionTypes.APPLICATION_TOGGLE_HEADER_NAVIGATION
	};
};

export const storeAuthorizationJsonFromLocalStorage = json => ({
	type: applicationActionTypes.AUTHORIZATION_TOKEN_DATA,
	payload: json
});

export const updateWindowDimensions = (height, width) => ({
	type: applicationActionTypes.APPLICATION_SCREEN_SIZE_UPDATE,
	height,
	width
});

export const userSubscriptionExpired = expired => ({
	type: applicationActionTypes.USER_SUBSCRIPTION_EXPIRED,
	expired
});


// WEBPACK FOOTER //
// ./src/settings/actions/application-actions.js